import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

var solid = defineStyle({
    bg: "linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%), var(--Neutral-900, #121417)",
    color: "white",
    borderRadius: "lg !important",
    borderColor: "neutrals.700",
    fontWeight: "500",
    boxShadow: "shadow-btn",
    _hover: {
        bg: "neutrals.700",
        borderColor: "neutrals.600",
        _disabled: {
            bg: "disable.bg",
            color: "disable.color",
        },
    },
    _focusVisible: {
        boxShadow: "outline",
    },
    _disabled: {
        bg: "disable.bg",
        color: "disable.color",
        cursor: "not-allowed",
        boxShadow: "none",
        border: "none",
        opacity: 1,
    },
    _loading: {
        bg: "linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%), var(--Neutral-900, #121417)",
        color: "white",
    },
    _active: {
        bg: "linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%), var(--Neutral-900, #121417)",
        boxShadow: "0px 4px 4px 0px #000 inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.25)",
        color: "white",
    },
});
var icon = defineStyle({
    color: "primary.900",
    minWidth: "fit-content",
    height: "fit-content",
    ".chakra-icon": {
        height: "16px",
        width: "16px",
        m: "1",
    },
    _hover: {
        bg: "neutrals.200",
        borderRadius: "4px",
    },
    _focusVisible: {
        bg: "neutrals.200",
        border: "1px solid",
        borderColor: "primary.900",
        borderRadius: "4px",
        boxShadow: "none",
    },
    _disabled: {
        color: "neutrals.500",
        opacity: "unset",
    },
});
var outline = defineStyle({
    borderRadius: "xl",
    borderColor: "neutrals.600",
    color: "neutrals.900",
    fontWeight: "400",
    _hover: {
        bg: "neutrals.200",
        _disabled: {
            bg: "disable.bg",
            color: "disable.color",
        },
    },
    _focusVisible: {
        boxShadow: "outline",
    },
    _disabled: {
        bg: "white",
        color: "neutrals.500",
        borderColor: "neutrals.500",
        cursor: "not-allowed",
        boxShadow: "none",
        opacity: 1,
    },
    _active: {
        bg: "neutrals.900",
        color: "white",
        borderColor: "#bec3c9",
    },
    _loading: {
        color: "black",
    },
});
var secondary = defineStyle({
    color: "neutrals.900",
    borderRadius: "lg !important",
    border: "1px solid",
    borderColor: "neutrals.500",
    bg: "#FFF",
    fontWeight: "500",
    boxShadow: "shadow-btn",
    _hover: {
        border: "1px solid",
        borderColor: "neutrals.600",
        _disabled: {
            border: "1px solid",
            borderColor: "neutrals.400",
            bg: "white",
        },
    },
    _focusVisible: {
        boxShadow: "outline",
    },
    _disabled: {
        bg: "white",
        color: "neutrals.500",
        border: "1px solid",
        borderColor: "neutrals.400",
        cursor: "not-allowed",
        boxShadow: "none",
        opacity: 1,
    },
    _active: {
        bg: "neutrals.100",
        color: "neutrals.900",
        borderColor: "neutrals.400",
    },
    _loading: {
        color: "black",
    },
});
var ghost = defineStyle({
    color: "primary.800",
    borderRadius: "lg !important",
    fontWeight: "500",
    _hover: {
        bg: "neutrals.100",
    },
    _disabled: {
        color: "neutrals.500",
        cursor: "not-allowed",
        opacity: 1,
    },
    _loading: {
        color: "black",
    },
});
var destructive = defineStyle({
    borderRadius: "lg !important",
    bg: "error.700",
    color: "neutrals.white",
    boxShadow: "shadow-btn",
    fontWeight: "500",
    _hover: {
        bg: "error.800",
        _disabled: {
            bg: "neutrals.200",
            color: "neutrals.500",
        },
    },
    _disabled: {
        bg: "neutrals.200",
        color: "neutrals.500",
        boxShadow: "none",
        cursor: "not-allowed",
        opacity: 1
    },
    _active: {
        bg: "error.700",
        boxShadow: "0px 4px 4px 0px #9C1F14 inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.25)",
    },
    _loading: {
        bg: "error.800",
        color: "neutrals.white",
    },
});
var buttonTheme = defineStyleConfig({
    variants: { solid: solid, icon: icon, outline: outline, secondary: secondary, ghost: ghost, destructive: destructive },
});

export { buttonTheme, buttonTheme as default };
//# sourceMappingURL=button.js.map
